import { useQuery } from "react-query";
import { getLeasedEquipmentSupplyAlertProfileList } from "../../../../../actions/Utilities/LeasedEquipmentSupplyAlertProfile";

export default function useGetSupplyAlertProfileList() {
  return useQuery("GetSupplyAlertProfile", getLeasedEquipmentSupplyAlertProfileList, {
    refetchOnWindowFocus: false,
  });
}
